import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import CopyFieldIcon from "components/CopyField/Icon";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableRowActionsCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps}>
      <CopyFieldIcon
        title="Copy ID"
        value={sharedModule.id}
        callback={() => trackAnalytics("Copy ID")}
      />
    </TableSimpleCell>
  );
};

export default SharedModulesTableRowActionsCell;
